import { accreditationLogosCarousel } from '../components/accreditation-logos-carousel';

accreditationLogosCarousel('#accreditations-logos');
